// Application Constants
export const APP_NAME = 'Protagon';
export const APP_VERSION = '1.0.0';

// API Configuration
// Prefer environment variable (Netlify/Vercel) and fall back to default
export const API_BASE_URL = 'https://api.protagon.ai';
export const API_URL = `${API_BASE_URL}/api`;

// Fallback image for articles without a specific image
export const FALLBACK_ARTICLE_IMAGE = 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80';

// Additional constants
export const CONSTANTS = {
  APP_NAME: 'Protagon'
};

export const PROFESSION_CATEGORIES = [
  'Accounting',
  'Valuation',
  'Tax',
  'Medicine',
  'Engineering',
  'Project Management',
  'Software Development',
  'Architecture',
  'Law',
  'Consulting',
  'Marketing',
  'Finance',
  'Education',
  'Research',
  'Business Analysis',
  'Data Science',
  'Other'
];

export const DIFFICULTY_LEVELS = [
  'Beginner',
  'Intermediate',
  'Advanced',
  'Expert'
];

export const PE_POINTS_RANGE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

// Updated to use full language names instead of abbreviated codes
export const LANGUAGES = ['English', 'Dutch', 'German', 'Spanish'];

// Language mapping for backward compatibility and API communication
export const LANGUAGE_MAP = {
  'en': 'English',
  'nl': 'Dutch', 
  'de': 'German',
  'es': 'Spanish'
};

// Reverse mapping for converting full names to codes if needed
export const LANGUAGE_CODE_MAP = {
  'English': 'en',
  'Dutch': 'nl',
  'German': 'de', 
  'Spanish': 'es'
}; 